import styled from "styled-components";



export const PrincipalDiv = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  display: flex;
  align-items: center;
  padding: 5rem 0 3rem 0;
`;

export const ContactDiv = styled.div`
  padding: 10px;
  margin-left: 10px;




  .marquee {
    width: 100%;
    white-space: nowrap;  
    position: relative;
  }

  .marquee-text {
    display: inline-block;
    padding-left: 100%;   
    animation: marquee 20s linear infinite;
    font-size: 2.8rem;
    font-weight: bold;
    color: white;
  }

  @keyframes marquee {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-100%); }
  }

  @media (max-width: 1000px) {
    width: 100%;
    margin-left: 0;
    padding: 5px;
  }
`;

